import { DETACHED_PREFIX } from "constants/proposals";

export const getInitialDetachParams = (childSections = []) => {
  return childSections.reduce((acc, section) => {
    const { nextgenDocumentId, nextgenFileName } = section;
    if (!nextgenDocumentId) {
      return acc;
    }

    const exists = acc[nextgenDocumentId];
    return exists
      ? acc
      : {
          ...acc,
          [nextgenDocumentId]: `${DETACHED_PREFIX}${nextgenFileName}`,
        };
  }, {});
};

export const areDetachParamsValid = (detachParams = {}) => {
  const keys = Object.keys(detachParams);
  return (
    keys.length > 0 && keys.every((key) => Boolean(detachParams[key]?.trim()))
  );
};
